function shouldBePlural(_count) {
    const count = Array.isArray(_count) ? _count.length : _count;
    return count !== 1;
}
/**
 * @example
 * // returns "1 Octopus"
 * formatPlural(1, Octopus)
 *
 * @example
 * // returns "5 Fives"
 * formatPlural([5, 5, 5, 5, 5], "Five")
 */
export function formatPluralCount(noun, count) {
    if (!shouldBePlural(count))
        return `${count} ${noun}`;
    return `${count} ${formatPlural(noun)}`;
}
export function formatPlural(noun, count) {
    if (count && !shouldBePlural(count))
        return noun;
    return `${noun}s`;
}
//# sourceMappingURL=formatPlural.js.map